import React, {Component} from 'react'
import {browserHistory} from 'react-router'
import {Col, Row, Image, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {IoRibbonB, FaHeartbeat} from '../ReactIcons/icons'
import { PersianNumber } from 'react-persian'

import './HorseAdBox.css'

const defaultHorseImage = `http://${window.location.host}/horse.jpg`
const coverMale = `http://${window.location.host}/cover-male.jpg`
const coverFemale = `http://${window.location.host}/cover-female.jpg`
const defaultAvatar = `http://${window.location.host}/default_avatar.png`

class HorseAdBox extends Component {
  render () {
    const tooltipGoodStrain = (
      <Tooltip id="tooltip">تیره‌ی همسان</Tooltip>
    )
    const {ad} = this.props
    const {horse} = ad
    return (
      <Col key={horse.id} xs={12} sm={6} md={4} lg={3} className="HorseAdBox" onClick={() => browserHistory.push(`/ad/${ad.id}`)}>
        <div className="MainBox">
          <Row>
            <OverlayTrigger placement="left" overlay={<Tooltip id="horse-like-counticon">تعداد لایک‌ها</Tooltip>} >
              <FaHeartbeat className="CoverLike" />
            </OverlayTrigger>
            <span className="CoverLikeText">{horse.likeCount}</span>
            {(horse.isGoodStrain) ? <OverlayTrigger placement="right" overlay={tooltipGoodStrain}><IoRibbonB className="CoverGoodStrain" title="Good Strain" /></OverlayTrigger> : null}
            <Image src={(horse.genderType === 'male') ? coverMale : coverFemale} alt="" className="Cover" />
          </Row>
          <Row>
            <Col xs={6} xsOffset={3} className="AvatarBox">
              <Image src={(horse.avatar) ? horse.avatar : defaultHorseImage} alt="" className="Avatar" />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h3 className="Name">{horse.name}</h3>
              <h4 className="Strain">{horse.strain !== null ? horse.strain : '(نامشخص)'}</h4>
            </Col>
          </Row>
          <Row className="HorseParent">
            <Col xs={4} className="Sire">
              {horse.sire.key !== null ? <Image src={(horse.sire.avatar) ? horse.sire.avatar : defaultHorseImage} alt="" className="Avatar" /> : <Image src={defaultHorseImage} alt="" className="Avatar" />}
              <h5 className="Name">{horse.sire.name}</h5>
              <h6 className="Strain">{horse.sire.strain !== null ? horse.sire.strain : '(نامشخص)'}</h6>
            </Col>
            <Col xs={4} xsOffset={4} className="Dam">
              {horse.dam.key !== null ? <Image src={(horse.dam.avatar) ? horse.dam.avatar : defaultHorseImage} alt="" className="Avatar" /> : <Image src={defaultHorseImage} alt="" className="Avatar" />}
              <h5 className="Name">{horse.dam.name}</h5>
              <h6 className="Strain">{horse.dam.strain !== null ? horse.dam.strain : '(نامشخص)'}</h6>
            </Col>
          </Row>
          <Row className="Footer">
            {ad.price > 0 ? <h6 className="Price"><PersianNumber>{parseInt(ad.price, 10).toLocaleString()}</PersianNumber> <span>تومان</span></h6> : <h6 className="Price zero">توافقی</h6>}
            <div className="OwnerUser"><Image src={ad.user.avatar ? ad.user.avatar : defaultAvatar} /> <span className="UserName">{ad.user.name ? ad.user.name : ad.user.username}</span></div>
          </Row>
        </div>
      </Col>
    )
  }
}

HorseAdBox.propTypes = {
  ad: React.PropTypes.object
}

export default HorseAdBox



// WEBPACK FOOTER //
// ./src/components/Common/HorseAdBox/HorseAdBox.js